import { Log, LogStatus, RouteSelectionMode } from '@/types/logs'
import { RouteReassignment } from '@/types/hub'

export const groupReassignedLogs = (logs: Log[], reassignedRoutes: RouteReassignment[]): Log[] => {
    const reassignedLogs: {
        [route: string]: Log[]
    } = {}

    if (!reassignedRoutes.length) {
        return []
    }

    logs.forEach((log) => {
        const reassignedRoute = reassignedRoutes.find(
            (route) => log.routes.includes(route.route) && log.routeSelectionMode !== RouteSelectionMode.None
        )

        if (reassignedRoute) {
            reassignedLogs[reassignedRoute.route] = [
                ...(reassignedLogs[reassignedRoute.route] || []),
                { ...log, reassignedRoute },
            ]
        }
    })

    return Object.values(reassignedLogs)
        .flat()
        .filter((log) => {
            const isOfficialReportActionDisplayed =
                log.codeTypeReasonInfo?.isOfficialReportRequired || log.report || log.report
            const isMechanicalInfoActionDisplayed =
                log.codeTypeReasonInfo?.isMechanicalInfoRequired || log.mechanicalInfo || log.mechanicalInfo
            const isIncompleteDisplayed = log.status === LogStatus.Incomplete
            return isOfficialReportActionDisplayed || isMechanicalInfoActionDisplayed || isIncompleteDisplayed
        })
}
